var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-tutorial-indicator__dot",class:{ 'is-active': _vm.isActive }},[_c('a',{on:{"click":_vm.slideTo}})])}
var staticRenderFns = []

export { render, staticRenderFns }